import { Box, Container, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import { SchoolSettings } from '../components/settings/SchoolSettings';
import { UserPreferences } from '../components/settings/UserPreferences';
import { AuditLog } from '../components/settings/AuditLog';
import { SubstitutionRulesTab } from '../components/settings/SubstitutionRulesTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

export function SettingsPage() {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="settings tabs">
          <Tab label="School" id="settings-tab-0" aria-controls="settings-tabpanel-0" />
          <Tab label="User" id="settings-tab-1" aria-controls="settings-tabpanel-1" />
          <Tab label="Substitution Rules" id="settings-tab-2" aria-controls="settings-tabpanel-2" />
          <Tab label="System" id="settings-tab-3" aria-controls="settings-tabpanel-3" />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <SchoolSettings />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <UserPreferences />
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <SubstitutionRulesTab />
      </TabPanel>

      <TabPanel value={tabValue} index={3}>
        <AuditLog />
      </TabPanel>
    </Container>
  );
}
